module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Lock-overturning-ef613c21f747221199fe9c1d0c1d269b.svg";